// extracted by mini-css-extract-plugin
export default {"Box":"slider_Box__n2aka","sliderdiv":"slider_sliderdiv__PsPA7"};